import styled, { css } from 'styled-components';

import { Button, Input } from '@xsolla/ui-core';

import { VerticalHorizontalCenterColumnBlock } from '../../../styled';

export const Wrapper = styled.div<{ inline: boolean }>`
  display: ${(props) => (props.inline ? 'inline-block' : 'block')};
  position: relative;

  div {
    min-width: 0;
  }
`;

const compactStyles = css`
  height: 25px;
  width: 55px;
  padding: 0 23px 0 8px;
  line-height: 28px;
`;

export const StyledInput = styled(Input)<{ compact: boolean }>`
  ${(props) => props.theme.typography.description};
  color: ${(props) => props.theme.colors.text};
  ${(props) => props.compact && compactStyles}

  appearance: textfield;
  margin: 0;

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus-visible,
  &:not([readonly]):hover,
  &:not([readonly]):focus,
  &:active {
    color: ${(props) => props.theme.colors.text};
  }
`;

export const StyledButton = styled(Button)`
  height: 12px;
  width: 24px;
  overflow: hidden;
  color: ${(props) => props.theme.colors.muted};
`;

export const IconWrapper = styled(VerticalHorizontalCenterColumnBlock)`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
`;
